import React from "react";

const AnimatedDisclaimer = () => {
  const styles = {
    wrapper: {
      display: "block",
      color: "#F8FAFC",
      fontWeight: 600,
      fontSize: "0.95rem",
      textAlign: "center",
      marginBottom: "18px",
      padding: "12px 18px",
      lineHeight: 1.55,
      borderRadius: "12px",
      background: "rgba(255,255,255,0.06)",
      backdropFilter: "blur(4px)",
      border: "1px solid rgba(255,255,255,0.08)",
      boxShadow: "0 4px 18px rgba(0,0,0,0.15)",
      animation: "gentlePulse 4s ease-in-out infinite",
    },
    highlight: {
      color: "#93C5FD", // soft trustworthy sky-blue
      fontWeight: 700,
    },
    sub: {
      marginTop: 6,
      fontSize: "0.78rem",
      fontWeight: 400,
      color: "rgba(241,245,249,0.82)",
    },
  };

  return (
    <>
      <style>
        {`
          @keyframes gentlePulse {
            0% {
              transform: scale(1);
              box-shadow: 0 4px 18px rgba(0,0,0,0.12);
              opacity: 0.96;
            }
            50% {
              transform: scale(1.015);
              box-shadow: 0 6px 24px rgba(0,0,0,0.2);
              opacity: 1;
            }
            100% {
              transform: scale(1);
              box-shadow: 0 4px 18px rgba(0,0,0,0.12);
            }
          }
        `}
      </style>

      <span style={styles.wrapper}>
        Use your <span style={styles.highlight}>school email</span> to sign-in
        <div style={styles.sub}>
          Your sign-in is securely handled by Auth0 (via Google/Microsoft/passwordless) — we never see your password.
        </div>
      </span>
    </>
  );
};

export default AnimatedDisclaimer;
